import { render, staticRenderFns } from "./EditTaxId.vue?vue&type=template&id=0a3b635b"
import script from "./EditTaxId.vue?vue&type=script&lang=js"
export * from "./EditTaxId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports